import { ProtectedRoute } from '@jadwalh/ui';
import Layout from '../layout';
import { Navigate, Outlet, useNavigate, useRoutes } from 'react-router-dom';
import { useRoutesConst } from '.';
import NoMatch from '../views/NoMatch';
import EditClient from '../views/clients/components/clientDetails/components/details/popup-edit';
import Error from '../views/error';
import Home from '../views/home';
import { SubscriptionGuard } from '../components/SubscriptionGuard';

const Routes = () => {
  const { ROUTES } = useRoutesConst();
  const navigate = useNavigate();

  const routes = useRoutes([
    {
      path: '/',
      element: <Layout />,
      errorElement: <Error />,
      children: [
        {
          path: '',
          element: (
            <ProtectedRoute>
              <SubscriptionGuard>
                <Home />
              </SubscriptionGuard>
            </ProtectedRoute>
          ),
          children: [
            {
              path: '',
              element: <Navigate to={ROUTES.appointments.to()} />,
            },

            {
              path: ROUTES.appointments.path,
              element: <Outlet />,
              children: [
                { index: true, element: ROUTES.appointments.component },
                {
                  path: ROUTES.addAppointment.path,
                  element: ROUTES.addAppointment.component,
                },
                {
                  path: ROUTES.detailsAppointments.path,
                  element: ROUTES.detailsAppointments.component,
                },
              ],
            },
            {
              path: ROUTES.reservationTimes.path,
              element: <Outlet />,
              children: [
                { index: true, element: ROUTES.reservationTimes.component },
                {
                  path: ROUTES.blockTimes.path,
                  element: <Outlet />,
                  children: [
                    { index: true, element: ROUTES.blockTimes.component },
                    {
                      path: ROUTES.addBlockTime.path,
                      element: ROUTES.addBlockTime.component,
                    },
                    {
                      path: ROUTES.editBlockTime.path,
                      element: ROUTES.editBlockTime.component,
                    },
                  ],
                },
                {
                  path: ROUTES.bookingTables.path,
                  element: <Outlet />,
                  children: [
                    { index: true, element: ROUTES.bookingTables.component },
                    {
                      path: ROUTES.addBookingTable.path,
                      element: ROUTES.addBookingTable.component,
                    },
                    {
                      path: ROUTES.editBookingTable.path,
                      element: ROUTES.editBookingTable.component,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTES.events.path,
              element: <Outlet />,
              children: [
                { index: true, element: ROUTES.events.component },
                {
                  path: ROUTES.addEvents.path,
                  element: <Outlet />,
                  children: [
                    { index: true, element: ROUTES.addEvents.component },
                    {
                      path: ROUTES.eventOneToOne.path,
                      element: ROUTES.eventOneToOne.component,
                    },
                    {
                      path: ROUTES.eventOneToGroup.path,
                      element: ROUTES.eventOneToGroup.component,
                    },
                    {
                      path: ROUTES.collectiveEvent.path,
                      element: ROUTES.collectiveEvent.component,
                    },
                    {
                      path: ROUTES.eventTour.path,
                      element: ROUTES.eventTour.component,
                    },
                    {
                      path: ROUTES.eventPolls.path,
                      element: ROUTES.eventPolls.component,
                    },
                  ],
                },
                {
                  path: ROUTES.editEventOneToOne.path,
                  element: <Outlet />,
                  children: [
                    {
                      index: true,
                      element: ROUTES.editEventOneToOne.component,
                    },
                  ],
                },
                {
                  path: ROUTES.editEventOneToGroup.path,
                  element: <Outlet />,
                  children: [
                    {
                      index: true,
                      element: ROUTES.editEventOneToGroup.component,
                    },
                  ],
                },
                {
                  path: ROUTES.editEventTour.path,
                  element: <Outlet />,
                  children: [
                    {
                      index: true,
                      element: ROUTES.editEventTour.component,
                    },
                  ],
                },
                {
                  path: ROUTES.editEventCollective.path,
                  element: <Outlet />,
                  children: [
                    {
                      index: true,
                      element: ROUTES.editEventCollective.component,
                    },
                  ],
                },
                {
                  path: ROUTES.editEventMeetingPolls.path,
                  element: <Outlet />,
                  children: [
                    {
                      index: true,
                      element: ROUTES.editEventMeetingPolls.component,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTES.clients.path,
              element: <Outlet />,
              children: [
                {
                  index: true,
                  element: ROUTES.clients.component,
                },
                {
                  path: ROUTES.clientDetail.path,
                  element: ROUTES.clientDetail.component,
                  children: [
                    { path: 'edit', element: <EditClient /> },
                  ],
                },
              ],
            },
            {
              path: ROUTES.models.path,
              element: <Outlet />,
              children: [
                {
                  index: true,
                  element: ROUTES.models.component,
                },
                {
                  path: ROUTES.updateModel.path,
                  element: ROUTES.updateModel.component,
                },
                {
                  path: ROUTES.replies.path,
                  element: ROUTES.replies.component,
                },
              ],
            },
            {
              path: ROUTES.workflows.path,
              element: <Outlet />,
              children: [
                {
                  index: true,
                  element: ROUTES.workflows.component,
                },
                {
                  path: ROUTES.updateWorkflow.path,
                  element: ROUTES.updateWorkflow.component,
                },
              ],
            },
            {
              path: ROUTES.analytics.path,
              element: <Outlet />,
              children: [
                {
                  index: true,
                  element: ROUTES.analytics.component,
                },
              ],
            },
            {
              path: ROUTES.identity.path,
              element: ROUTES.identity.component,
            },

            {
              path: ROUTES.reservation.path,
              element: <Outlet />,
              children: [
                {
                  index: true,
                  element: ROUTES.reservation.component,
                },

                {
                  path: ROUTES.cancellationPolicy.path,
                  element: ROUTES.cancellationPolicy.component,
                },
              ],
            },

            {
              path: ROUTES.members.path,
              element: <Outlet />,
              children: [
                { index: true, element: ROUTES.members.component },
                {
                  path: ROUTES.member.path,
                  element: <Outlet />,
                  children: [
                    { index: true, element: ROUTES.member.component },
                    {
                      path: ROUTES.addMember.path,
                      element: ROUTES.addMember.component,
                    },
                    {
                      path: ROUTES.editMember.path,
                      element: ROUTES.editMember.component,
                    },
                  ],
                },
                {
                  path: ROUTES.memberGroups.path,
                  element: <Outlet />,
                  children: [
                    { index: true, element: ROUTES.memberGroups.component },
                  ],
                },
              ],
            },
            {
              path: ROUTES.team.path,
              element: <Outlet />,
              children: [
                { index: true, element: ROUTES.team.component },
                {
                  path: ROUTES.addTeam.path,
                  element: ROUTES.addTeam.component,
                },
                {
                  path: ROUTES.editTeam.path,
                  element: ROUTES.editTeam.component,
                },
              ],
            },

            {
              path: ROUTES.profileData.path,
              element: ROUTES.profileData.component,
            },
            {
              path: ROUTES.managementProfile.path,
              element: ROUTES.managementProfile.component,
            },
            {
              path: ROUTES.calenderSync.path,
              element: ROUTES.calenderSync.component,
            },
            {
              path: ROUTES.subscription.path,
              element: ROUTES.subscription.component,
            },
            {
              path: ROUTES.customDomain.path,
              element: ROUTES.customDomain.component,
            },
            {
              path: ROUTES.integration.path,
              element: <Outlet />,
              children: [
                { index: true, element: ROUTES.integration.component },
                {
                  path: ROUTES.googleAnalytics.path,
                  element: ROUTES.googleAnalytics.component,
                },
                {
                  path: ROUTES.googleCalendar.path,
                  element: ROUTES.googleCalendar.component,
                },
              ],
            },
            {
              path: ROUTES.settings.path,
              element: ROUTES.settings.component,
            },
            {
              path: ROUTES.logOut.path,
              element: ROUTES.logOut.component,
            },
            {
              path: ROUTES.subscriptionSuspended.path,
              element: ROUTES.subscriptionSuspended.component,
            },
            {
              path: ROUTES.plans.path,
              element: ROUTES.plans.component,
            },
            {
              path: ROUTES.planSummary.path,
              element: ROUTES.planSummary.component,
            },
          ],
        },
        {
          path: ROUTES.deactivateClients.path,
          element: (
            <ProtectedRoute>
              {ROUTES.deactivateClients.component}
            </ProtectedRoute>
          ),
        },
        {
          path: ROUTES.invitation.path,
          element: <Outlet />,
          children: [
            {
              index: true,
              element: ROUTES.invitation.component,
            },
          ],
        },
        {
          path: ROUTES.googleLoginRedirect.path,
          element: ROUTES.googleLoginRedirect.component,
        },
        {
          path: ROUTES.authSections.path,
          element: ROUTES.authSections.component,
          children: [
            { index: true, element: ROUTES.loginOptions.component },
            {
              path: ROUTES.signIn.path,
              element: ROUTES.signIn.component,
            },
            {
              path: ROUTES.otpVerify.path,
              element: ROUTES.otpVerify.component,
            },
            {
              path: ROUTES.chooseAccount.path,
              element: ROUTES.chooseAccount.component,
            },
            {
              path: ROUTES.newAccount.path,
              element: ROUTES.newAccount.component,
            },
            {
              path: ROUTES.register.path,
              element: ROUTES.register.component,
            },
            {
              path: ROUTES.verifyEmail.path,
              element: ROUTES.verifyEmail.component,
            },
          ],
        },
        {
          path: ROUTES.registerSections.path,
          element: ROUTES.registerSections.component,
          children: [
            { index: true, element: ROUTES.registerOptions.component },
            {
              path: ROUTES.register.path,
              element: ROUTES.register.component,
            },
            {
              path: ROUTES.otpVerify.path,
              element: ROUTES.otpVerify.component,
            },
            {
              path: ROUTES.registerEmail.path,
              element: ROUTES.registerEmail.component,
            },
            {
              path: ROUTES.verifyEmailAfterRegister.path,
              element: ROUTES.verifyEmailAfterRegister.component,
            },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <NoMatch />,
    },
    {
      path: '/error',
      element: <Error />,
    },
  ]);
  return routes;
};

export default Routes;
